import $ from "jquery";
import ko from "knockout";
import _ from "lodash";

const showErrorIcon = function (element, errorValue) {
    const errorIcon = $(element)
        .parents("div.accordion-item")
        .find(".accordion-status-indicator");
    if (errorIcon.length > 0) {
        errorIcon.toggleClass("hidden", !errorValue);
    }
};

/**
 * Usage Examples
 *
 * <div data-bind="formGroup: myObservable">
 *     <div> ... </div>
 * </div>
 *
 * Optional Data Option:
 * data-enable-tooltip-indicator: when true, formats the element to display the
 * error icon in the header of the accordion binding
 *
 * formGroup elements must be a DOM descendant of an element bound with form. There
 * can be many formGroups per form.
 *
 * Each formGroup should have a controlMessage to display an error and optionally a
 * formControl to detect when the error should be re-hidden. There should be one formGroup
 * per validated observable.
 *
 * The behavior of formGroup is that upon validation, it applies the 'has-error'
 * style if there is an error.
 */
ko.bindingHandlers.formGroup = {
    init: function (element, valueAccessor) {
        const observable = valueAccessor();

        // Set element class.
        $(element).addClass("form-group");

        // The form group will register with a parent form.
        const $form = $(element).closest(".pc-form, form");
        if ($form.length === 0) {
            throw new Error("Detected a formGroup outside of a form!");
        }
        const formGroupList = ko.utils.domData.get($form[0], "formGroupList");
        const groupListEntry = {
            groupElement: element,
            observable: observable,
        };
        formGroupList.push(groupListEntry);

        // Cleanup
        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            const formGroupList = ko.utils.domData.get(
                $form[0],
                "formGroupList"
            );
            if (formGroupList) {
                const index = formGroupList.indexOf(groupListEntry);
                if (index !== -1) {
                    formGroupList.splice(index, 1);
                }
            }
        });
    },
    update: function (element, valueAccessor) {
        const observable = valueAccessor();

        const $form = $(element).closest(".pc-form, form");
        if ($form.length > 0) {
            const formGroupList = ko.utils.domData.get(
                $form[0],
                "formGroupList"
            );
            if (formGroupList) {
                const groupListEntry = _.find(formGroupList, {
                    groupElement: element,
                });
                if (
                    groupListEntry &&
                    groupListEntry.observable !== observable
                ) {
                    groupListEntry.observable = observable;
                }
            }
        }

        let errorIconFormatting = false;
        if ($(element).attr("data-enable-tooltip-indicator") === "true") {
            errorIconFormatting = true;
        }

        if (observable.isModified && observable.isValid && observable.error) {
            const hasError = observable.isModified() && !observable.isValid();
            $(element).toggleClass("has-error", hasError);
            if (errorIconFormatting) {
                showErrorIcon(element, hasError);
            }
        }
    },
};
